module.exports = __webpack_public_path__ + "static/img-13-0dcbcb7e24f25437e9c2c78bac4401c8.jpeg";